import { useEffect, useCallback } from 'react';
import { observer } from 'mobx-react';
import { CircularProgress } from 'uiKit/atoms/CircularProgress/CircularProgress';
import { formatMessageDate } from 'helpers/utils';
import { useStores } from 'stores';
import AnotherUserMessage from './AnotherUserMessage/AnotherUserMessage';
import OwnMessage from './OwnMessage/OwnMessage';

const Messages = observer(() => {
  const {
    userStore: { userProfile },
    messageStore: { isLoading, messages, currentConversation, getMessages },
  } = useStores();

  const newConversationId = -1;

  useEffect(() => {
    // fetch corresponding messages on currentConversation id change
    if (currentConversation > 0) {
      getMessages(currentConversation);
    }
  }, [currentConversation]);

  const showDate = useCallback(
    msgIndex => {
      // todo this is probably not very efficient
      const prevIndex = msgIndex - 1;
      if (messages[msgIndex] && messages?.[prevIndex]) {
        if (formatMessageDate(messages[msgIndex].added) === formatMessageDate(messages[prevIndex].added)) {
          return false;
        }
      }

      return true;
    },
    [messages]
  );

  const getMessageComponent = useCallback(
    userId => {
      if (userId === userProfile.id) {
        return OwnMessage;
      }
      return AnotherUserMessage;
    },
    [userProfile]
  );

  if (isLoading) {
    return <CircularProgress disableShrink className="circular-progress" />;
  }

  return (
    Number(currentConversation) !== newConversationId &&
    messages.map((message, index) => {
      const MessageComponent = getMessageComponent(message.userId);
      return <MessageComponent key={message.id} message={message} showDate={showDate(index)} />;
    })
  );
});

export default Messages;
